<template>
 <v-app>
   <UserAccounts></UserAccounts>
   <two-factor-authenticate></two-factor-authenticate>
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex  xs12 sm8 md6 lg5 class="custom-lg4">
             <img src="../../assets/images/unoapp.png" class="form-head-logo mb-2"/>
            <v-card class="elevation-12">
              <offset-heading 
              titleClass="mb-0 headline font-weight-bold"
              title="ENTER YOUR PHONE NUMBER" 
              subtitle="Enter the 10-digit phone number associated to your account"></offset-heading>
              <v-card-text class="nmt-20 px-5 phone-no-login-form pt-7 mt-5">
                <v-form ref="login-form">
                  <v-text-field
                  v-model="user.phone"
                  :rules="phoneRules"
                  prepend-icon="local_phone"
                  required
                  validate-on-blur
                  name="Phone Number"
                  label="Phone Number"
                  type="number">
                  </v-text-field>
                  <div class="px-5">
                    <v-btn
                      color="primary"
                      fab
                      medium
                      @click="GetAuthenticationCode($event)"
                    >
                      <v-icon dark>fas fa-long-arrow-alt-right</v-icon>
                    </v-btn>
                     <v-card-text role="button">
                      <router-link class="normal-link" :to="{ name: 'Login'}"> <i class="fas fa-long-arrow-alt-left backarrow"></i> Go back</router-link>
                    </v-card-text>
                  </div>
                </v-form>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
import { mapActions } from 'vuex';
import NormalApi from '@/components/Controllers/NormalApi'; // Just naming as readable
import Helper from '@/components/Controllers/Helpers';
import Env from '@/env';

export default {
  name: 'LoginWithPhoneNumber',
  // data: () => ({
  data() {
    return {
      user: {
        phone: '1010101010',
      },
      phoneRules: [
        v => !!v || 'Phone number is required',
        v => /^\d{10}$/.test(v) || 'Phone number must be 10-digit',
      ],
    };
  },
  props: {
    source: String,
  },
  methods: {
    /**
     * Handles the Login with phone number
     */
    GetAuthenticationCode() {
      if (this.$refs['login-form'].validate()) {
        this.spinner(true);
        const url = `${Env.url}/api/v1/users/login/phone`;
        NormalApi.postApi(url,{
          'api-token': Env.apiToken 
        }, this.user)
          .then((res) => {
            this.spinner(false);
            this.$store.dispatch('SET_USER_LOGIN_STEP', '2_factor_authenticate');  
            this.snackbar({
              text: res.data.msg,
              timeout: 3000,
              open: true,
            });
          })
          .catch((err) => {
            this.spinner(false);
            this.snackbar({
              text: 'Please try again later.',
              timeout: 3000,
              open: true,
            });
          });
      }
    },
    ...mapActions({
      snackbar: 'snackbar/snackbar',
      spinner: 'spinner/spinnerStatus',
    }),
  },
};
</script>


<style scoped>
@media only screen and (max-width: 1200px) {
 .v-application .phone-no-login-form{
    margin-top: 30px !important;
  }
}
@media only screen and (max-width: 700px) {
 .v-application .phone-no-login-form{
    margin-top: 66px !important;
  }
}
@media only screen and (min-width: 1300px) {
  .flex.lg5.custom-lg4 {
      -ms-flex-preferred-size: 33.3333333333%;
      flex-basis: 33.3333333333%;
      -webkit-box-flex: 0;
      -ms-flex-positive: 0;
      flex-grow: 0;
      max-width: 33.3333333333%;
  }
}
</style>
